export enum Message {
  instanceRequired = "instanceRequired",
  instanceIdRequired = "instanceIdRequired",
  instanceTypeFolder = "instanceTypeFolder",
  instanceType = "instanceType",
  instancePathLength = "instancePathLength",
  userRequired = "userRequired",
  databaseId = "databaseId",
}
